import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import ButtonEditor from '../../../components/Editor/ButtonEditor';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			editableButtons,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
		},
	} = state;

	const { page, id } = ownProps;
	const {
		isVisible,
		isThemedItem,
		hasLink,
		linkData,
		inDesignAction,
		isLocked,
	} = editableButtons[page][id];

	return {
		isActive: id === activeItem.id && page === activeItem.page,
		isVisible,
		isEditPanelDisplayed,
		isThemedItem,
		hasLink,
		linkData,
		inDesignAction,
		isLocked,
	};
};

export default connect(mapStateToProps)(ButtonEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonEditor/index.tsx